import constantObject from 'utilities/constantObject';

export const ROOT_PAGE_IDS = {
  OVERVIEW: '-100000',
  FAVORITES: '-100003',
  SHARED: '-100002',
  BIB: '-100006',
};

export const BIB_PAGE_IDS = [
  '-100007',
  '-100008',
  '-100009',
  '-100010',
  '-100011',
  '-100012',
  '-100013',
  '-100014',
  '-100015',
  '-100018',
  '-100019',
  '-100020',
  '-100021',
  '-100022',
  '-100023',
  '-100024',
  '-100025',
];

export const RESOURCE_TYPES = constantObject(['PAGE', 'CARD']);
